import cjson from 'compressed-json';
import { Component, EventEmitter, OnDestroy, OnInit, Type, ViewChild } from '@angular/core';
import { PersonSearchService } from '../_services/person-search.service';
import { UntypedFormControl } from '@angular/forms';
import { MatAutocompleteTrigger as MatAutocompleteTrigger } from '@angular/material/autocomplete';
import * as _ from 'underscore';
import * as __ from 'lodash';
import { Subject, Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { debounceTime, filter } from 'rxjs/operators';
import { LocalStorageService } from '../_services/local-storage.service';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { FilterDataHandlerService } from '../_services/filter-data-handler.service';
import { FilterParams } from '../common-interfaces-classes/FilterParams';
import { GeneralConstants } from '../constants/GeneralConstants';
import { SuggestedTitle } from '../openai/suggested-titles/suggested-titles.component';
import { ContinentHandlerService } from '../_services/continent-handler.service';
import { GlobalService } from '../_services/global.service';
import { TalentInsightsReqHandlerService } from '../_services/talent-insights-req-handler.service';
import { JdData } from '../common-interfaces-classes/JdData';
import { DataService } from '../data.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { JdDataService } from '../jd-data.service';
import { SimilarCandidateFilterComponent } from '../similar-candidate-filter/similar-candidate-filter.component';
import { AggReqObjectHandlerService } from '../_services/agg-req-object-handler.service';
import { HashService } from '../_services/hash.service';
import { SimilarCandidateDetails } from '../common-interfaces-classes/SimilarCandidate';
import { SimilarCandidateService } from '../_services/similar-candidate.service';
import { TransactionService } from '../_services/transaction.service';
import { AggregationService } from '../_services/aggregation.service';
import { EuropeAccessModalComponent } from '../europe-access-modal/europe-access-modal.component';
import { TalentInsightsService } from '../_services/talent-insights.service';
declare const clevertap;

@Component({
    selector: 'app-talentpool-insights',
    templateUrl: './talentpool-insights.component.html',
    styleUrls: ['./talentpool-insights.component.scss'],
    standalone: false
})
export class TalentpoolInsightsComponent implements OnInit, OnDestroy {

  /**Constact for Tabs in talentpool insights page */
  INSIGHTS_TAB = {
    QUICK_SEARCH: 'quick-search',
    JD_SEARCH: 'jd-search'
  }

  @ViewChild(MatAutocompleteTrigger) autocomplete: MatAutocompleteTrigger;

  private typeAheadSubject = new Subject<{ event: Event, type: String }>();
  requestObject: any;
  jobTitleList: any = []
  skillsList: any = []
  locationList: any;
  /**
   * Job Title Input for autocomplete
   */
  jobTitleInput: UntypedFormControl = new UntypedFormControl(null);
  /**
     * Job Title Selected List for autocomplete
     */
  jobTitleSelectedList: any = [];

  jobTitleTopList: any = [];

  locationInput: UntypedFormControl = new UntypedFormControl(null);
  locationSelectedList: any = [];
  // skills
  skillsInput: UntypedFormControl = new UntypedFormControl(null);

  skillsSelectedList: any = [];

  skillsTopList: any = [];
  regionEvent: Subject<any> = new Subject();
  showregion: string

  separatorKeysCodes: number[] = [ENTER, COMMA];

  pageNumber: number = 1;
  pageSize: number = 10;
  currentPage: number = 1;
  start: any //- start number for pagination (from)
  end: any //- end number for paginatuin (to)

  totalCandidatesCountLoading: boolean = false;
  totalCandidatesCount: any;
  showjobtitleloader: Boolean = false
  type: any

  keywordInput: UntypedFormControl = new UntypedFormControl(null);
  keywordsearch: any;
  searchDisable: Boolean = true;

  filterData: FilterParams;

  isOpenAITitleLoading: boolean = false;
  showOpenAITitleSuggestions: number;

  subscriptions: Array<Subscription> = [];

  /**Current tab in talent-insights front page */
  currentTab: string = this.INSIGHTS_TAB.JD_SEARCH;

  get openAITitles(): string {
    return this.jobTitleSelectedList.filter(jt => !jt.isSuggestion).map(jobTitle => `"${jobTitle.key.replace('.searchastext', '')}"`).join(' OR ') || '';
  }

  isOpenAISkillsLoading: boolean = false;
  showOpenAISkillsSuggestions: number;

  get openAISkills(): string {
    return this.skillsSelectedList.filter(jt => !jt.isSuggestion).map(skill => `"${skill.key.replace('.searchastext', '')}"`).join(' OR ') || '';
  }

  get openAIExcludeSkills(): string[] {
    return this.skillsSelectedList.map(skill => skill.chipkey);
  }

  get openAIExcludeJobTitles(): string[] {
    return this.jobTitleSelectedList.map(jobTitle => jobTitle.chipkey);
  }

  keyWordInputValue: string = '';

  get openAIAll(): string {
    const jobTitle = this.jobTitleSelectedList.filter(jt => !jt.isSuggested).map(jobTitle => `"${jobTitle.chipkey}"`);
    const skills = this.skillsSelectedList.filter(s => !s.isSuggested).map(skill => `"${skill.chipkey}"`);
    const keyword = this.keyWordInputValue && this.keyWordInputValue.trim() ? `"${this.keyWordInputValue}"` : null;

    return keyword ? [keyword].concat(jobTitle).concat(skills).join(' OR ') || '' : jobTitle.concat(skills).join(' OR ') || '';
  }

  get jobtitleAndSkillAIData(): { boolean?: string | null, jobtitles?: string[], skills?: string[] } {
    return {
      boolean: this.keyWordInputValue && this.keyWordInputValue.trim() ? this.keyWordInputValue : null,
      jobtitles: this.jobTitleSelectedList.filter(jt => !jt.isSuggested).map(jobTitle => jobTitle.chipkey),
      skills: this.skillsSelectedList.filter(s => !s.isSuggested).map(skill => skill.chipkey)
    }
  }

  updatedAiTitleChips: EventEmitter<SuggestedTitle[]> = new EventEmitter<SuggestedTitle[]>();
  updatedAiSkillChips: EventEmitter<SuggestedTitle[]> = new EventEmitter<SuggestedTitle[]>();

  aiSuggestedTitles: SuggestedTitle[] = [];
  aiSuggestedSkills: SuggestedTitle[] = [];

  get jobTitleAggregateType(): string {
    return 'current_jobtitle';
  }

  get jobTitleType(): string {
    return 'Current';
  }
  hasEUTalentInsightsAccess: number;
  redirectType: string;
  locationContinent: any = [];
  similarobject: any;

  constructor(
    private personSearchService: PersonSearchService,
    private router: Router, private _localstorageservice: LocalStorageService,
    private talentInsightsReqHandlerService: TalentInsightsReqHandlerService,
    private filterDataHandlerService: FilterDataHandlerService, private continentHandlerService: ContinentHandlerService,
    private dataService: DataService,
    private modalService: NgbModal, private jdDataService: JdDataService,
    private aggReqObjectHandlerService: AggReqObjectHandlerService,
    private hashService: HashService,
    private similarCandidateService: SimilarCandidateService,
    private transactionService: TransactionService,
    private aggsService: AggregationService,
    private talentInsightsService: TalentInsightsService,
    private route: ActivatedRoute

  ) {
    this._localstorageservice.setItem('talentRegion', null)
  }

  ngOnInit(): void {
    this.redirectType = this.route.snapshot.queryParamMap.get('type');

    //TODO
    // const jdsubscription = this.jdDataService.jdDataEventObs.subscribe(response => this.openSimilarCandidateFilters(response, true));
    // this.subscriptions.push(jdsubscription);
    if(this.redirectType == 'nl-search'){

  const jdsubscription = this.jdDataService.jdDataForRedirect.subscribe(response => {
      if (response) {
        this.openSimilarCandidateFilters(response, true);
    this.jdDataService.clearjdData();
      }
    })
    this.subscriptions.push(jdsubscription);
  }

  const jdsubscription = this.jdDataService.jdDataEventObs.subscribe(response => this.openJDSimilarCandidateFilters(response, true));
    this.subscriptions.push(jdsubscription);



    this.filterDataHandlerService.reset();
    this.filterDataHandlerService.setBooleanQuery();
    this.filterData = this.filterDataHandlerService.fetchFilterData;
    this.getTotalCandidateCount();

    this.showregion = this._localstorageservice.getItem('talentRegion')
    // if (!this.showregion) {
    //   this.showregion = 'asia';
    //   this._localstorageservice.setItem('talentRegion', 'asia');
    // }
    // this.showregion = this.showregion ? this.showregion : 'asia';
    const loadn = document.querySelectorAll<HTMLElement>('.loading-screen-wrapper');
    //loadn[0].style.display = 'none'
    this._localstorageservice.setItem('talentfilters', '')
    this.filterDataHandlerService.reset();
    this.filterDataHandlerService.setBooleanQuery();
    this._localstorageservice.setItem(GeneralConstants.LS_KEYS.TALENT_FILTERS, JSON.stringify(this.filterDataHandlerService.fetchFilterData));
    //this.buildReport()

    const typeAheadSub = this.typeAheadSubject.pipe(debounceTime(500)).subscribe(({ event, type }) => {
      this.typeAheadSearch(event, type);
    });
    this.subscriptions.push(typeAheadSub);

    const continentUpdateSub = this.continentHandlerService.continentUpdateObservable.subscribe(continent => this.selectRegion(continent));
    this.subscriptions.push(continentUpdateSub);
    this.hasEUTalentInsightsAccess = this._localstorageservice.getItem('hasEUTalentInsightsAccess');

  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
    const filterData = this.filterDataHandlerService.fetchFilterData;
    filterData.locationcontinents = [];
    this.filterDataHandlerService.setFilterData(filterData);
  }

  typeAheadSearch(event, type: String) {
    const requestObject = {
      "startindex": 0,
      "resultsize": 10,
      "searchviaboolean": true,
      "booleanquery": "*",
      "jobtitles": [],
      "preferredskills": [],
      "mandatoryskills": [],
      "locations": [],
      "companies": [],
      "industries": [],
      "exclusionlist": [],
      "genders": [
        "All"
      ],
      "seniority": [
        "All"
      ],
      "graduationyear": [],
      "schools": [],
      "schooltypes": [],
      "educationaldegrees": [],
      "educationalmajors": [],
      "candidateshavingemails": false,
      "candidateshavingcontactnumbers": false,
      "minexperience": null,
      "maxexperience": null,
      "minexperienceinccurrentcompany": null,
      "zipcodes": [],
      "companysizes": [
        "All"
      ],
      "candidateshavingcontacts": false,
      "workregions": [],
      "workcountries": [],
      "worklocalities": [],
      "spokenlanguages": [],
      "contacts": [
        "All"
      ],
      "candidateshavingmobilenumber": false,
      "candidateshavingpersonalemail": false,
      "candidateshavingprofessionalemail": false,
      "candidateshavingsocialprofiles": false,
      "fromgraduationyear": null,
      "tograduationyear": null,
      "exclude_jobtitles": [],
      "exclude_companies": [],
      "exclude_locations": [],
      "companytype": "Current",
      "jobtitletype": "Current",
      "industrytype": "Current",
      "fromyearsofexperience": [],
      "toyearsofexperience": [],
      "experiencetype": "Total",
      "likelytomovetype": null,
      "salaries": [
        "All"
      ],
      "salaryranges": [
        "All"
      ],
      "functions": [],
      "continentstobeincluded": [this._localstorageservice.getItem('talentRegion')]
    };
    const searchValue = event.target.value;
    //   const searchValue = (event.target as HTMLInputElement).value.trim();
    switch (type) {
      case 'jobtitle': {
        if (searchValue.length > 2) {
          this.personSearchService.getPersonSearchListing(searchValue, 'jobtitle').subscribe((response: any) => {
            if (response.status == 'success') {
              this.jobTitleList = response.data.slice(0, 10);

            }
          });
        }

        break
      }
      case 'skills': {
        if (searchValue.length > 2) {

          this.personSearchService.getPersonSearchListing(searchValue, 'skill').subscribe((response: any) => {
            if (response.status == 'success' && response.data) {
              this.skillsList = response.data;
            }
          });
        }
        break;
      }
      case 'location': {
        if (searchValue.length > 2) {
          // let data = {
          //   keyword: searchValue,
          //   type: "location",
          //   continent: [this._localstorageservice.getItem('talentRegion')]
          // }
          this.personSearchService.getPersonSearchListing(searchValue, "location").subscribe((response: any) => {
            if (response.status == 'success' && response.data) {
              this.locationList = response.data;
            }
          });
        }
        break;
      }
    }
  }

  // Call the function whenever user type something
  onTypeAheadSearch(event: Event, type: String) {
    // Emit the type and event as object through typeAheadSubject to apply debouce
    this.typeAheadSubject.next({ event, type });
  }

  selectedItem(event, type, from: any = null) {
    if (event != '') {
      switch (type) {
        case "jobtitle": {
          this.jobTitleList = []
          if (from == 'enter')
            this.jobTitleSelectedList.push({ key: event + ".searchastext", chipkey: event, isExcluded: false, isMandatory: false });
          else
            this.jobTitleSelectedList.push({ key: event.value + ".searchastext", chipkey: event.value, isExcluded: false, isMandatory: false })
          this.jobTitleSelectedList = _.uniq(this.jobTitleSelectedList, "key");
          this.jobTitleInput.reset();
          break;
        }
        case "skills": {
          this.skillsList = []
          if (from == 'enter')
            this.skillsSelectedList.push({ key: event + ".searchastext", chipkey: event, isExcluded: false, isMandatory: false })
          else
            this.skillsSelectedList.push({ key: event.value, chipkey: event.value, isExcluded: false, isMandatory: false })
          this.skillsSelectedList = _.uniq(this.skillsSelectedList, "key");
          this.skillsInput.reset();
          break;
        }
        case "location": {
          if ((this.hasEUTalentInsightsAccess == 1) && event?.location_continent == 'europe' && type == 'location') {
            this.locationInput.setValue(event.key);
            const euData = this._localstorageservice.getItem('euConscent');
            const now = new Date().getTime();

            if (euData) {
              const parsedData = JSON.parse(euData);
              if (!parsedData.lastShown || now - parseInt(parsedData.lastShown, 10) > 24 * 60 * 60 * 1000) {
                const modalRef = this.modalService.open(EuropeAccessModalComponent, { windowClass: 'euAccessModal', centered: true, backdrop: 'static', keyboard: false });
                modalRef.result.then((res) => {
                  if (res.action == "success") {
                    this.locationList = []
                    if (from == 'enter')
                      this.locationSelectedList.push({ key: event + ".searchastext", chipkey: event, isExcluded: false, isMandatory: false })
                    else
                      this.locationSelectedList.push({ key: event.value, chipkey: event.value, isExcluded: false, isMandatory: false, continent: event?.location_continent });
                    this.locationSelectedList = _.uniq(this.locationSelectedList, "key");
                    this.locationInput.reset();
                  } else {
                    this.locationInput.reset();
                    this.locationList = []
                  }
                })
              } else
                this.locationList = []
              if (from == 'enter')
                this.locationSelectedList.push({ key: event + ".searchastext", chipkey: event, isExcluded: false, isMandatory: false })
              else
                this.locationSelectedList.push({ key: event.value, chipkey: event.value, isExcluded: false, isMandatory: false, continent: event?.location_continent });
              this.locationContinent = _.uniq(_.pluck(this.locationSelectedList, 'continent'));
              this.locationSelectedList = _.uniq(this.locationSelectedList, "key");
              this.locationInput.reset();
            } else {
                   const modalRef = this.modalService.open(EuropeAccessModalComponent, { windowClass: 'euAccessModal', centered: true, backdrop: 'static', keyboard: false });
                modalRef.result.then((res) => {
                  if (res.action == "success") {
                    this.locationList = []
                    if (from == 'enter')
                      this.locationSelectedList.push({ key: event + ".searchastext", chipkey: event, isExcluded: false, isMandatory: false })
                    else
                      this.locationSelectedList.push({ key: event.value, chipkey: event.value, isExcluded: false, isMandatory: false, continent: event?.location_continent });
                                  this.locationContinent = _.uniq(_.pluck(this.locationSelectedList, 'continent'));

                    this.locationSelectedList = _.uniq(this.locationSelectedList, "key");
                    this.locationInput.reset();
                  } else {
                    this.locationInput.reset();
                    this.locationList = []
                  }
                })
            }
          } else {
            this.locationList = []
            if (from == 'enter')
              this.locationSelectedList.push({ key: event + ".searchastext", chipkey: event, isExcluded: false, isMandatory: false })
            else
              this.locationSelectedList.push({ key: event.value, chipkey: event.value, isExcluded: false, isMandatory: false, continent: event?.location_continent })
              this.locationContinent = _.uniq(_.pluck(this.locationSelectedList, 'continent'));
            this.locationSelectedList = _.uniq(this.locationSelectedList, "key");
            this.locationInput.reset();
          }

          break;
        }
      }
      this.syncFilterData();
      this.filterDataHandlerService.setFilterData(this.filterData);
      this.buildReport()
    }
  }
  removeChip(value, type) {
    switch (type) {
      case 'jobtitle':
        this.jobTitleSelectedList = this.jobTitleSelectedList.filter(item => item.chipkey !== value);
        break;

      case 'skills':
        this.skillsSelectedList = this.skillsSelectedList.filter(item => item.chipkey !== value);
        break;

      case 'location':
        this.locationSelectedList = this.locationSelectedList.filter(item => item.chipkey !== value);
        break;

    }
    this.syncFilterData();
    this.filterDataHandlerService.setFilterData(this.filterData);
    (this.jobTitleSelectedList.length || this.skillsSelectedList.length) && this.buildReport()
  }

  /** Get total candidate count on talentpool-insights page */
  getTotalCandidateCount() {
    this.totalCandidatesCountLoading = true;
    const reqBody = this.talentInsightsReqHandlerService.talentInsightRequest;
    reqBody['fetchtotalpersoncountincontinent'] = true;
    reqBody['continentstobeincluded'] = [];
    this.personSearchService.getTotalAggs(reqBody).subscribe(res => {
      this.totalCandidatesCountLoading = false;
      this.totalCandidatesCount = res?.data?.totalresultscount;
    })

  }

  selectedValue(searchValue) {
    if (searchValue !== null || searchValue !== "") {
      this.keywordsearch = searchValue.trim();
      this.keyWordInputValue = searchValue.trim();
      this.searchDisable = false;
      this.syncFilterData();
      this.filterDataHandlerService.setFilterData(this.filterData);
      this.buildReport()
    }
  }

  /**
   *
   * This method is specifically used for jd search and on first load or page refresh
   */
  private openSimilarCandidateFilters(jdResponse: JdData, firstLoad = false) {
       this.requestObject = {
      startindex: 0,
      resultsize: 0,
      searchviaboolean: true,
      booleanquery: this.keywordsearch ? this.keywordsearch : "*",
      iscurrent: false,
      currentcompaniesonly: false,
      pastcompaniesonly: false,
      jobtitles: this.jobTitleSelectedList.map(jobTitle => jobTitle.key),
      preferredskills: this.skillsSelectedList.map(skill => skill.key),
      mandatoryskills: [],
      companies: [],
      industries: [],
      exclusionlist: [],
      genders: ['All'],
      seniority: ['All'],
      graduationyear: [],
      schools: [],
      schooltypes: [],
      educationaldegrees: [],
      educationalmajors: [],
      candidateshavingemails: false,
      candidateshavingcontactnumbers: false,
      minexperience: null,
      maxexperience: null,
      minexperienceinccurrentcompany: null,
      zipcodes: [],
      companysizes: ['All'],
      candidateshavingcontacts: false,
      workregions: [],
      workcountries: [],
      worklocalities: [],
      spokenlanguages: [],
      contacts: [],
      candidateshavingmobilenumber: false,
      candidateshavingpersonalemail: false,
      candidateshavingprofessionalemail: false,
      candidateshavingsocialprofiles: false,
      companytype: 'All',
      jobtitletype: 'Current',
      industrytype: 'All',
      experiencetype: 'Total',
      fromyearsofexperience: [],
      toyearsofexperience: [],
      locations: this.locationSelectedList.map(l => l.key),
      continentstobeincluded: this.locationContinent.length ? this.locationContinent: [],
      functions: [],
      fullnames: [],
      distancefromselectedlocationsmeasurementunit: 'kilometers',
      distancefromselectedlocations: 20,
    };

    this.similarCandidateService.emitSimilarCandidateEvent();
    this.personSearchService.passsimilarcandidatesdata(jdResponse);
    this.similarobject = jdResponse ? jdResponse : new SimilarCandidateDetails();
   // this.buildReport('redirect', this.redirectType == 'nl-search' ? GeneralConstants.REDIRECT_SOURCES.NL_SEARCH : GeneralConstants.REDIRECT_SOURCES.JOB_DESCRIPTION, this.similarobject);
    // console.log('similarobject', this.similarobject)

     this.requestObject.job_description_keys = this.jdDataService.getJdKeys(this.similarobject);

      const uniqueHash = this.hashService.generateUniqueHash();
      if(this.requestObject.job_description_keys?.locations?.length > 0){
         const locations = this.requestObject.job_description_keys?.locations?.map(loc => loc.replace('.searchastext',''));
      const payload = {locations: locations}
      this.talentInsightsService.getLocationCurrency(payload).subscribe((res:any)=>{
        if(res.status === 'success' && res.data){
          this._localstorageservice.setItem('jobCurrency', res.data.base_currency);
          this._localstorageservice.setItem('currencyCountry', res.data.country_name);

        }
      })
      this.locationContinent = this.locationContinent.length ? this.locationContinent : this.similarobject.locationcontinent ? [this.similarobject.locationcontinent] : [];
    } else {
      this._localstorageservice.setItem('jobCurrency', 'USD');
      this._localstorageservice.setItem('currencyCountry', null);
    }
          this.jdDataService.setSessionData(uniqueHash, this.similarobject);

          const localKey = GlobalService.hash(JSON.stringify(cjson.compress(this.filterData)))
          localStorage.setItem(localKey, JSON.stringify(cjson.compress(this.filterData)));
          this.jdDataService.setJDDataInTIReportDetails('jdUpdate')
          this.router.navigate([`/report-details/report-overview`], { queryParams: { type: this.redirectType, uniqueHash, filter: localKey } });
  }

  /**
   * Function used to convert request object format to filterData format
   * Not in use now, but will use it later if needed
   * @param reqObj
   */
  reqObjToFilterParamConversion(reqObj) {
    this.filterDataHandlerService.reset();
    this.filterDataHandlerService.setBooleanQuery();
    const filterData = this.filterDataHandlerService.fetchFilterData;
    const filterFormat = {
      isExcluded: false,
      isMadatory: false,
      key: '',
      chipkey: ''
    }
    Object.keys(reqObj).map(key => {
      switch (key) {
        case 'companysizes': {
          if (reqObj[key]?.length) {
            filterData['companySizeSelectedList'] = reqObj[key];
            filterData['isCompanySizeSelected'] = true;
          }
          break;
        }
        case 'jobtitles': {
          if (reqObj[key]?.length) {
            filterData['jobTitleSelectedList'] = reqObj[key].map(item => {
              const tempObj = __.cloneDeep(filterFormat);
              tempObj.key = item;
              tempObj.chipkey = item;
              return tempObj;
            })
          }
          break;
        }
        case 'locations': {
          if (reqObj[key]?.length) {
            filterData['locationSelectedList'] = reqObj[key].map(item => {
              const tempObj = __.cloneDeep(filterFormat);
              tempObj.key = item;
              tempObj.chipkey = item;
              return tempObj;
            })
          }
          break;
        }
        case 'educationaldegrees': {
          if (reqObj[key]?.length) {
            filterData['educationSelectedList'] = reqObj[key].map(item => {
              const tempObj = __.cloneDeep(filterFormat);
              tempObj.key = item;
              tempObj.chipkey = item;
              return tempObj;
            })
          }
          break;
        }
        case 'fromyearsofexperience': {
          if (reqObj[key]?.length) {
            filterData['yearsofexperienceFrom'] = reqObj[key][0];
            filterData['filterAppliedOnYearsOfExperience'] = true;
          }
          break;
        }
        case 'toyearsofexperience': {
          if (reqObj[key]?.length) {
            filterData['yearsofexperienceTo'] = reqObj[key][0];
            filterData['filterAppliedOnYearsOfExperience'] = true;
          }
          break;
        }
        case 'companies': {
          if (reqObj[key]?.length) {
            filterData['companySelectedList'] = reqObj[key].map(item => {
              const tempObj = __.cloneDeep(filterFormat);
              tempObj.key = item;
              tempObj.chipkey = item;
              return tempObj;
            })
          }
          break;
        }
        case 'industries': {
          if (reqObj[key]?.length) {
            filterData['industrySelectedList'] = reqObj[key].map(item => {
              const tempObj = __.cloneDeep(filterFormat);
              tempObj.key = item;
              tempObj.chipkey = item;
              return tempObj;
            })
          }
          break;
        }

        case 'continentstobeincluded': {
          if (reqObj[key]?.length)
            filterData['continentstobeincluded'] = reqObj[key];
          break;
        }
        case 'schools': {
          if (reqObj[key]?.length) {
            filterData['schoolSelectedList'] = reqObj[key].map(item => {
              const tempObj = __.cloneDeep(filterFormat);
              tempObj.key = item;
              tempObj.chipkey = item;
              return tempObj;
            })
          }
          break;
        }
        case 'mandatoryskills': {
          if (reqObj[key]?.length) {
            filterData['skillsSelectedList'] = reqObj[key].map(item => {
              const tempObj = __.cloneDeep(filterFormat);
              tempObj.key = item;
              tempObj.chipkey = item;
              tempObj.isMadatory = true;
              return tempObj;
            })
          }
          break;
        }
        case 'preferredskills': {
          if (reqObj[key]?.length) {
            const tempArr = reqObj[key].map(item => {
              const tempObj = __.cloneDeep(filterFormat);
              tempObj.key = item;
              tempObj.chipkey = item;
              return tempObj;
            })
            filterData['skillsSelectedList'] = filterData['skillsSelectedList'].concat(tempArr);
          }
          break
        }
      }
    });
    this.filterData = filterData
  }


  selectRegion(region) {
    this.showregion = region
    this._localstorageservice.setItem('talentRegion', region)
    this.regionEvent.next(this.showregion)
    this.buildReport()
  }

  buildReport(type?, calledfrom?: string, reqObj?) {
    this.requestObject = {
      startindex: 0,
      resultsize: 0,
      searchviaboolean: true,
      booleanquery: this.keywordsearch ? this.keywordsearch : "*",
      iscurrent: false,
      currentcompaniesonly: false,
      pastcompaniesonly: false,
      jobtitles: this.jobTitleSelectedList.map(jobTitle => jobTitle.key),
      preferredskills: this.skillsSelectedList.map(skill => skill.key),
      mandatoryskills: [],
      companies: [],
      industries: [],
      exclusionlist: [],
      genders: ['All'],
      seniority: ['All'],
      graduationyear: [],
      schools: [],
      schooltypes: [],
      educationaldegrees: [],
      educationalmajors: [],
      candidateshavingemails: false,
      candidateshavingcontactnumbers: false,
      minexperience: null,
      maxexperience: null,
      minexperienceinccurrentcompany: null,
      zipcodes: [],
      companysizes: ['All'],
      candidateshavingcontacts: false,
      workregions: [],
      workcountries: [],
      worklocalities: [],
      spokenlanguages: [],
      contacts: [],
      candidateshavingmobilenumber: false,
      candidateshavingpersonalemail: false,
      candidateshavingprofessionalemail: false,
      candidateshavingsocialprofiles: false,
      companytype: 'All',
      jobtitletype: 'Current',
      industrytype: 'All',
      experiencetype: 'Total',
      fromyearsofexperience: [],
      toyearsofexperience: [],
      locations: this.locationSelectedList.map(l => l.key),
      continentstobeincluded: this.locationContinent.length ? this.locationContinent: [this._localstorageservice.getItem('defaultContinent')],
      functions: [],
      fullnames: [],
      distancefromselectedlocationsmeasurementunit: 'kilometers',
      distancefromselectedlocations: 20,
    };

    const param = {
      // keyword: this.hashService.encryptString(this.keywordsearch)
      keyword: this.keywordsearch
    }
    if(this.locationSelectedList.length > 0){
      const locations = this.locationSelectedList.map(loc => loc.key.replace('.searchastext',''));
      const location = locations.join(',');
      const payload = {locations: locations}
      this.talentInsightsService.getLocationCurrency(payload).subscribe((res:any)=>{
        if(res.status === 'success' && res.data){
          this._localstorageservice.setItem('jobCurrency', res.data.base_currency);
          this._localstorageservice.setItem('currencyCountry', res.data.country_name);
        }
      })

    } else {
      this._localstorageservice.setItem('jobCurrency', 'USD');
      this._localstorageservice.setItem('currencyCountry', null);
    }
    if(type === 'redirect' && calledfrom === 'jd-search' && reqObj){
      this.requestObject.searchedfrom = GeneralConstants.REDIRECT_SOURCES.JOB_DESCRIPTION;
      this.requestObject.job_description_keys = this.jdDataService.getJdKeys(reqObj);
      if(this.redirectType == 'nl-search')
        this.requestObject.nlsearchquery = this._localstorageservice.getItem('nlSearchKeyword')
      const uniqueHash = this.hashService.generateUniqueHash();
      if(this.requestObject.job_description_keys?.locations?.length > 0){
         const locations = this.requestObject.job_description_keys?.locations?.map(loc => loc.replace('.searchastext',''));
      const payload = {locations: locations}
      this.talentInsightsService.getLocationCurrency(payload).subscribe((res:any)=>{
        if(res.status === 'success' && res.data){
          this._localstorageservice.setItem('jobCurrency', res.data.base_currency);
          this._localstorageservice.setItem('currencyCountry', res.data.country_name);

        }
      })
      this.locationContinent = this.locationContinent.length ? this.locationContinent : reqObj.locationcontinent ? [reqObj.locationcontinent] : [];
    } else {
      this._localstorageservice.setItem('jobCurrency', 'USD');
       this._localstorageservice.setItem('currencyCountry', null);

    }


      this.jdDataService.setSessionData(uniqueHash, reqObj);
      param['uniqueHash'] = uniqueHash;
      param['type'] = GeneralConstants.REDIRECT_SOURCES.JOB_DESCRIPTION;
    }

    if (this.jobTitleSelectedList.length > 0) {
      this.requestObject['aggregatetype'] = 'skills';
    } else {
      this.requestObject['aggregatetype'] = 'current_jobtitle';
    }

    (type == 'redirect') && this.setTalentInsightsHistory(__.cloneDeep(this.requestObject));
         if (type == 'redirect'  && calledfrom === 'jd-search') {
          this.type = 'redirect';
          const filter = JSON.stringify({ jobtitle: this.requestObject['jobtitles'], skills: this.requestObject['preferredskills'], location: this.requestObject['locations'], totalcount: this.totalCandidatesCount })
          this._localstorageservice.setItem('talentfilters', filter);
          /**
           * Add to talentpool
           */
          const talentpoolParams = {
            "User ID": this._localstorageservice.getItem('userdata').userid,
            "Search Type": this.requestObject.searchedfrom ? "JD Search" : "Boolen",
            "Filters Applied": this.requestObject.searchedfrom ? JSON.stringify(this.requestObject.job_description_keys) : this._localstorageservice.getItem('talentfilters')
          }
          clevertap.event.push('Talent Insights Search', talentpoolParams);
          const region = type === 'redirect' ? this.locationContinent?.length > 0 ? this.locationContinent[0] : this._localstorageservice.getItem('defaultContinent'): this._localstorageservice.getItem('defaultContinent');
          this.filterData.continentstobeincluded.push(region)
          this._localstorageservice.setItem(GeneralConstants.LS_KEYS.TALENT_FILTERS, JSON.stringify(this.filterData));
          const localKey = GlobalService.hash(JSON.stringify(cjson.compress(this.filterData)))
          localStorage.setItem(localKey, JSON.stringify(cjson.compress(this.filterData)));
          param['filter'] = localKey;
          param[type] = this.redirectType;
          this.jdDataService.setJDDataInTIReportDetails('jdUpdate')
          this.router.navigate([`/report-details/report-overview`], { queryParams: param });
        } else {
    this.totalCandidatesCountLoading = true;
    this.personSearchService.getTotalAggs(this.requestObject).subscribe(response => {
      if (response.status == 'success') {
        this.totalCandidatesCountLoading = false;
        this.totalCandidatesCount = response.data.totalresultscount;
        if (type == 'redirect') {
          this.type = 'redirect';
          const filter = JSON.stringify({ jobtitle: this.requestObject['jobtitles'], skills: this.requestObject['preferredskills'], location: this.requestObject['locations'], totalcount: this.totalCandidatesCount })
          this._localstorageservice.setItem('talentfilters', filter);
          /**
           * Add to talentpool
           */
          const talentpoolParams = {
            "User ID": this._localstorageservice.getItem('userdata').userid,
            "Search Type": this.requestObject.searchedfrom ? "JD Search" : "Boolen",
            "Filters Applied": this.requestObject.searchedfrom ? JSON.stringify(this.requestObject.job_description_keys) : this._localstorageservice.getItem('talentfilters')
          }
          clevertap.event.push('Talent Insights Search', talentpoolParams);
          // const region = type === 'redirect' ? this.locationContinent[0] : this._localstorageservice.getItem('talentRegion');
          // this.filterData.continentstobeincluded.push(region)
          this._localstorageservice.setItem(GeneralConstants.LS_KEYS.TALENT_FILTERS, JSON.stringify(this.filterData));
          const localKey = GlobalService.hash(JSON.stringify(cjson.compress(this.filterData)))
          localStorage.setItem(localKey, JSON.stringify(cjson.compress(this.filterData)));
          param['filter'] = localKey;
          param[type] = this.redirectType;
          this.jdDataService.setJDDataInTIReportDetails('quickSearchUpdate')

          this.router.navigate([`/report-details/report-overview`], { queryParams: param });
        }
      }
    });
        }

  }


  /**
   * set history in talent insights
   * @param reqBody
   */
  setTalentInsightsHistory(reqBody) {
    delete reqBody['aggregatetype'];
    delete reqBody['aggregatescount'];
    delete reqBody['resultsize'];
    delete reqBody['startindex'];
    delete reqBody['talentdiscoveryhistoryid'];
    reqBody['seniority'] = [];
    reqBody['companysizes'] = [];
    reqBody['module'] = GlobalService.HISTORY_MODULE.TALENT_INSIGHTS;
    reqBody['continentstobeincluded'] = this.locationContinent?.length > 0 ? this.locationContinent: [this._localstorageservice.getItem('defaultContinent')];
    if(this.redirectType == 'job-description')
      delete reqBody.nlsearchquery;
    this.personSearchService.setInsightsHistory(reqBody).subscribe((res) => {
      if (res) {
        this._localstorageservice.setItem('talentInsightsHistoryId', res.talentdiscoveryhistoryid);
      }
    });
  }

  // not in indian format
  formatNumberToIndianFormat(number) {
    if (number) {
      const suffixes = ['', 'K+', 'M+', 'B+', 'T+']; // Add more suffixes as needed for larger numbers
      for (const suffix of suffixes) {
        if (Math.abs(number) < 1000) {
          return Math.floor(number) + suffix;
        }
        number /= 1000;
      }
      return Math.floor(number) + 'T';
    } else {
      return 0;
    }
  }
  resetFilters() {
    this.totalCandidatesCount = 0
    this.jobTitleSelectedList = []
    this.skillsSelectedList = []
    this.locationSelectedList = []
    this.keywordInput.patchValue(null);
    this.keyWordInputValue = '';
    this.keywordsearch = null;
    this.searchDisable = true;
    this.filterData.booleanquery = _.clone(this.keywordsearch, true);

    this.requestObject = {
      startindex: this.start,
      resultsize: 10,
      searchviaboolean: true,
      booleanquery: "*",
      iscurrent: false,
      currentcompaniesonly: false,
      pastcompaniesonly: false,
      jobtitles: [],
      preferredskills: [],
      mandatoryskills: [],
      companies: [],
      industries: [],
      exclusionlist: [],
      genders: [],
      seniority: [],
      graduationyear: [],
      schools: [],
      schooltypes: [],
      educationaldegrees: [],
      educationalmajors: [],
      candidateshavingemails: false,
      candidateshavingcontactnumbers: false,
      minexperience: null,
      maxexperience: null,
      minexperienceinccurrentcompany: null,
      zipcodes: [],
      companysizes: [],
      candidateshavingcontacts: false,
      workregions: [],
      workcountries: [],
      worklocalities: [],
      spokenlanguages: [],
      contacts: [],
      candidateshavingmobilenumber: [],
      candidateshavingpersonalemail: [],
      candidateshavingprofessionalemail: [],
      candidateshavingsocialprofiles: [],
      companytype: [],
      jobtitletype: [],
      industrytype: [],
      experiencetype: [],
      fromyearsofexperience: [],
      toyearsofexperience: [],
      locations: [],
      continentstobeincluded: [this._localstorageservice.getItem('talentRegion')]

    }
    this.filterDataHandlerService.reset();
    this.filterDataHandlerService.setBooleanQuery();
    this.buildReport();
  }

  getemptytypeahead(type) {
    const requestObject = {
      "startindex": 0,
      "resultsize": 10,
      "searchviaboolean": true,
      "booleanquery": "*",
      "jobtitles": [],
      "preferredskills": [],
      "mandatoryskills": [],
      "locations": [],
      "companies": [],
      "industries": [],
      "exclusionlist": [],
      "genders": [
        "All"
      ],
      "seniority": [
        "All"
      ],
      "graduationyear": [],
      "schools": [],
      "schooltypes": [],
      "educationaldegrees": [],
      "educationalmajors": [],
      "candidateshavingemails": false,
      "candidateshavingcontactnumbers": false,
      "minexperience": null,
      "maxexperience": null,
      "minexperienceinccurrentcompany": null,
      "zipcodes": [],
      "companysizes": [
        "All"
      ],
      "candidateshavingcontacts": false,
      "workregions": [],
      "workcountries": [],
      "worklocalities": [],
      "spokenlanguages": [],
      "contacts": [
        "All"
      ],
      "candidateshavingmobilenumber": false,
      "candidateshavingpersonalemail": false,
      "candidateshavingprofessionalemail": false,
      "candidateshavingsocialprofiles": false,
      "fromgraduationyear": null,
      "tograduationyear": null,
      "exclude_jobtitles": [],
      "exclude_companies": [],
      "exclude_locations": [],
      "companytype": "Current",
      "jobtitletype": "Current",
      "industrytype": "Current",
      "fromyearsofexperience": [],
      "toyearsofexperience": [],
      "experiencetype": "Total",
      "likelytomovetype": null,
      "salaries": [
        "All"
      ],
      "salaryranges": [
        "All"
      ],
      "functions": [],
      "continentstobeincluded": [this._localstorageservice.getItem('talentRegion')]
    };
    const searchValue = 'a'
    if (type == 'jobtitle') {
      this.personSearchService.getPersonSearchListing(searchValue, 'jobtitle').subscribe((response: any) => {
        if (response.status == 'success') {
          this.jobTitleList = response.data.slice(0, 10);
        }
      });
    } else if (type == 'skills') {
      this.personSearchService.getPersonSearchListing(searchValue, 'skill').subscribe((response: any) => {
        if (response.status == 'success') {
          this.skillsList = response.data.slice(0, 10);
        }
      });
    } else if (type == 'locations') {
      requestObject['typeahead'] = 'typeahead_location'
      requestObject['input'] = ''
      this.personSearchService.getTotalAggs(requestObject).subscribe((response: any) => {
        if (response.status == 'success') {
          this.locationList = response.data.aggs
        }
      });
    }
  }

  private syncFilterData() {
    this.filterData.jobTitleSelectedList = _.clone(this.jobTitleSelectedList, true);
    this.filterData.skillsSelectedList = _.clone(this.skillsSelectedList, true);
    this.filterData.locationSelectedList = _.clone(this.locationSelectedList, true);
    this.filterData.booleanquery = _.clone(this.keywordsearch, true);
    this.filterData.continentstobeincluded = _.uniq(_.pluck(this.locationSelectedList, 'continent'));
  }

  openaiTitleLoading({ state, count, suggested }) {
    this.isOpenAITitleLoading = state;
    this.showOpenAITitleSuggestions = count;

    suggested && (this.aiSuggestedTitles = suggested);
    this.openAIAll && !state && (suggested !== undefined && suggested !== null) && suggested.length < 5 && this.getFilterWiseDataToDisplay('jobtitle', true);
  }

  setTitleSuggestions(suggestions: SuggestedTitle[]) {
    // generate key for each suggestion
    const suggestionsWithKey = suggestions.map(suggestion => {
      return {
        key: `${suggestion.name}.aisearch`,
        chipkey: suggestion.name,
        isExcluded: false,
        isMandatory: false,
        isSuggestion: true,
        isSuggested: true,
        suggestedTitle: { name: suggestion.name, selected: true, type: 'title', key: this.getSafeKey(suggestion.name) }
      };
    });
    // existing suggestions
    const existingSuggestions = this.jobTitleSelectedList.filter(suggestion => suggestion.isSuggestion);
    // remove existing suggestions from new suggestions
    const newSuggestions = suggestionsWithKey.filter(suggestion => !existingSuggestions.find(existingSuggestion => existingSuggestion.chipkey === suggestion.chipkey));
    // add new suggestions to existing suggestions
    // @ts-ignore
    this.jobTitleSelectedList.push(...newSuggestions);
    if (newSuggestions.length) {
      this.syncFilterData();
      this.filterDataHandlerService.setFilterData(this.filterData);
      this.buildReport();
    }
  }

  openaiSkillsLoading({ state, count, suggested }) {
    this.isOpenAISkillsLoading = state;
    this.showOpenAISkillsSuggestions = count;

    suggested && (this.aiSuggestedSkills = suggested);
    this.openAIAll && !state && (suggested !== undefined && suggested !== null) && suggested.length < 5 && this.getFilterWiseDataToDisplay('skills', true);
  }

  setSkillsSuggestions(suggestions: SuggestedTitle[]) {
    const suggestionsWithKey = suggestions.map(suggestion => {
      return {
        key: `${suggestion.name}.aisearch`,
        chipkey: suggestion.name,
        isExcluded: false,
        isMandatory: false,
        isSuggestion: true,
        isSuggested: true,
        suggestedTitle: { name: suggestion.name, selected: true, type: 'title', key: this.getSafeKey(suggestion.name) }
      };
    });
    const existingSuggestions = this.skillsSelectedList.filter(suggestion => suggestion.isSuggestion);
    const newSuggestions = suggestionsWithKey.filter(suggestion => !existingSuggestions.find(existingSuggestion => existingSuggestion.chipkey === suggestion.chipkey));
    this.skillsSelectedList.push(...newSuggestions);
    if (newSuggestions.length) {
      this.syncFilterData();
      this.filterDataHandlerService.setFilterData(this.filterData);
      this.buildReport();
    }
  }

  private getSafeKey(str: string): string {
    return str.toLowerCase().replace(/[^a-zA-Z0-9]/g, '');
  }

  removeTypeahead(type: any) {
    const maxLength = 3
    switch (type) {
      case 'jobtitle': {
        if (!(this.jobTitleInput && this.jobTitleInput.value && this.jobTitleInput.value.length >= maxLength)) {
          this.jobTitleList = []
        }
        break;
      }
      case 'skills': {
        if (!(this.skillsInput && this.skillsInput.value && this.skillsInput.value.length >= maxLength)) {
          this.skillsList = []
        }
        break;
      }
      case 'location': {
        if (!(this.locationInput && this.locationInput.value && this.locationInput.value.length >= maxLength)) {
          this.locationList = []
        }
        break;
      }
    }
  }

  getFilterWiseDataToDisplay(filterName, callApi = false) {
    if (filterName === "jobtitle") {
      if (this.showOpenAITitleSuggestions && !callApi) return;
      this.getAggregationsForFilter("jobtitle", "jobtitle", callApi);
    }
    else if (filterName === "skills") {
      if (this.showOpenAISkillsSuggestions && !callApi) return;
      this.getAggregationsForFilter('skills', 'skills', callApi);
    }
  }

  getAggregationsForFilter(filterName: string, aggregateType: string, updateSelectedList = false) {
    const payload = this.requestObject;
    payload['aggregatetype'] = aggregateType;
    delete payload['typeahead']

    this.personSearchService.getTotalAggs(payload).subscribe(response => {
      if (response.status == 'success') {
        const reportsAggs = response.data.aggregations;
        switch (filterName) {
          case 'jobtitle': {
            this.jobTitleTopList = reportsAggs['jobtitle'];
            this.jobTitleTopList = this.jobTitleTopList.filter(jobTitle => !this.jobTitleSelectedList.some(selectedJobTitle => selectedJobTitle.chipkey.toLowerCase() == jobTitle.key.toLowerCase()))
            if (updateSelectedList) {
              const titlesToBeUpdated = [];
              let noOfSuggestionsToAdd = 5 - (this.aiSuggestedTitles ? this.aiSuggestedTitles.length : 0);
              noOfSuggestionsToAdd && this.jobTitleTopList.forEach((jobTitle) => {
                if (noOfSuggestionsToAdd) {
                  const isTitlePresent = this.aiSuggestedTitles.find(j => j.name.toLowerCase() == jobTitle.key.toLowerCase());
                  if (!isTitlePresent) {
                    titlesToBeUpdated.push({ name: jobTitle.key, selected: false, type: 'title', key: this.getSafeKey(jobTitle.key) });
                    noOfSuggestionsToAdd--;
                  }
                }
              });
              this.showOpenAITitleSuggestions += titlesToBeUpdated.length;
              this.updatedAiTitleChips.emit(titlesToBeUpdated);
            }
          }
          case 'skills': {
            this.skillsTopList = reportsAggs?.skills ? reportsAggs?.skills : [];
            this.skillsTopList = this.skillsTopList.filter(skill => !this.skillsSelectedList.some(selectedSkill => selectedSkill.chipkey.toLowerCase() == skill.key.toLowerCase()))
            if (updateSelectedList) {
              const skillsToBeUpdated = [];
              let noOfSuggestionsToAdd = 5 - (this.aiSuggestedSkills ? this.aiSuggestedSkills.length : 0);
              noOfSuggestionsToAdd && this.skillsTopList.forEach((skill) => {
                if (noOfSuggestionsToAdd) {
                  const isSkillPresent = this.aiSuggestedSkills.find(s => s.name.toLowerCase() == skill.key.toLowerCase());
                  if (!isSkillPresent) {
                    skillsToBeUpdated.push({ name: skill.key, selected: false, type: 'skill', key: this.getSafeKey(skill.key) });
                    noOfSuggestionsToAdd--;
                  }
                }
              });
              this.showOpenAISkillsSuggestions += skillsToBeUpdated.length;
              this.updatedAiSkillChips.emit(skillsToBeUpdated);
            }
          }
        }
      }
    });
  }

  onTabChange(tab) {
    this.currentTab = tab;
  }

  changeContinent() {
    // Access flags don't vary by which region tab is being viewed, so this just needs the
    // already-loaded signal, not a fresh network call.
    const accessData = this.transactionService.access();
    if (accessData) {
      this._localstorageservice.setItem('hasEUPersonSearchAccess', accessData.haseupersonsearchaccess);
      this._localstorageservice.setItem('hasEUTalentInsightsAccess', accessData.haseutalentinsightsaccess)
      const currentRegion = this._localstorageservice.getItem('talentRegion');
      if (currentRegion == 'europe' && !accessData.haseutalentinsightsaccess) {
        this.personSearchService.getGeoIpLocationOfUser.subscribe((response: any) => {
          const region = response.continent ? response.continent.toLowerCase() : 'asia';
          this.showregion = region;
          this._localstorageservice.setItem('talentRegion', region);
          this.aggsService.emitContinentEvent(this.showregion);
        });
      } else {
        this.aggsService.emitContinentEvent(currentRegion);
      }
    }
  }

  isLocationDisabled(location: any): boolean {
    return this.hasEUTalentInsightsAccess != 1 && location.location_continent.toLowerCase() === 'europe';

  }

  getTooltipText(location: any): string {
    if(this.isLocationDisabled(location)) {
      return 'This location cannot be selected due to GDPR regulations.\n As part of our commitment to EU data protection regulations, candidate personal data (PII) is not displayed or processed for EU-based profiles.';
    } else {
      return `${this.capitalizeFirst(location?.value)} | ${this.capitalizeFirst(location?.location_type)}`;
    }
  }

capitalizeFirst(value: string): string {
  if (!value) return '';

  return value
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

openJDSimilarCandidateFilters(jdResponse: JdData, firstLoad = false) {
   const similarobj = firstLoad ? this.jdDataService.getSimilarObj(jdResponse) : this.jdDataService.jdDataFromSession;
    this.personSearchService.passsimilarcandidatesdata({ data: similarobj, calledfrom: this.redirectType == 'nl-search' ? GeneralConstants.REDIRECT_SOURCES.NL_SEARCH : GeneralConstants.REDIRECT_SOURCES.JOB_DESCRIPTION });
    if(similarobj?.jobtitle?.length > 0) {
 this.similarCandidateService.emitSimilarCandidateEvent();
        this.personSearchService.passsimilarcandidatesdata(similarobj);
        const similarobject = similarobj ? similarobj : new SimilarCandidateDetails();
        this.buildReport('redirect', 'jd-search', similarobject);
    } else {
    const modalRef = this.modalService.open(SimilarCandidateFilterComponent, { size: 'xl', windowClass: 'modal-size', centered: true, });
    modalRef.componentInstance.disableDisableButton = firstLoad;
    modalRef.result.then((res) => {
      if (res.action == 'submit') {
        this.similarCandidateService.emitSimilarCandidateEvent();
        this.personSearchService.passsimilarcandidatesdata(res);
        const similarobject = res.data ? res.data : new SimilarCandidateDetails();
        this.buildReport('redirect', 'jd-search', similarobject);

      } else if (res.action === 'close' && firstLoad) {
        this.router.navigate([], { queryParams: {} })
      }
    });
    }
}

}
